<div
  id="user"
  class="page-layout blank p-24"
  class="page-layout simple"
  fxLayout="column">
  <!-- HEADER -->
  <div
    class="header-maintenance"
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayout.gt-sm="row"
    fxLayoutAlign.gt-sm="space-between end">
    <div
      class="name"
      [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }">
      {{ 'SUPPORT-ICT.MAINTENANCE-SETTINGS' | translate }}
    </div>
  </div>
  <!-- / HEADER -->
  <div class="content-maintenance" fxLayout="row wrap">
    <!-- CONTENT CARD -->
    @if (isLoading) {
      <mat-progress-bar
        color="accent"
        mode="indeterminate"
        class="mat-progress-bar"></mat-progress-bar>
    }
    <div class="content-card" fxFill>
      @if (!isLoading) {
        <div class="container">
          <!-- Top section with refresh button aligned to the right -->
          <div fxLayout="row" fxLayoutAlign="end center">
            <button
              style="
                cursor: pointer;
                background-color: transparent;
                border: none;
              "
              (click)="refresh()">
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
          <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="0px">
            <div fxFlex="100%" fxFlex.xs="100%">
              @for (categoryGroup of groupedData; track categoryGroup) {
                <div>
                  <div
                    style="
                      border-bottom: 1px solid #ccc;
                      margin-bottom: 20px;
                      padding-bottom: 10px;
                    ">
                    <div
                      fxLayout="row"
                      fxLayoutAlign="start center"
                      fxLayoutGap="10px">
                      <h3>{{ categoryGroup.category }}</h3>
                      <!-- Toggle for the category -->
                      @if (categoryGroup.category !== 'Full maintenance') {
                        <mat-slide-toggle
                          [(ngModel)]="categoryGroup.allItemsDisabled"
                          [disabled]="isSpecialItemToggled"
                          (change)="onCategoryToggle(categoryGroup)">
                        </mat-slide-toggle>
                      }
                    </div>
                    <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="0px">
                      <div fxFlex="50%" fxFlex.xs="100%">
                        @for (
                          item of getFirstHalf(categoryGroup.items);
                          track item
                        ) {
                          <div style="margin-bottom: 15px">
                            <div
                              fxLayout="row"
                              fxLayoutAlign="start center"
                              fxLayoutGap="10px">
                              <!-- All item toggle -->
                              @if (
                                categoryGroup.category === 'Full maintenance'
                              ) {
                                <mat-slide-toggle
                                  [(ngModel)]="item.isDisabled"
                                  (change)="
                                    onSpecialItemToggle($event.checked)
                                  ">
                                </mat-slide-toggle>
                              }
                              <!-- Regular items toggle -->
                              @if (
                                categoryGroup.category !== 'Full maintenance'
                              ) {
                                <mat-slide-toggle
                                  [(ngModel)]="item.isDisabled"
                                  [disabled]="isSpecialItemToggled"
                                  (change)="onToggle(item.url)">
                                </mat-slide-toggle>
                              }
                              <span>
                                {{ item.label }}
                                ({{
                                  item.url +
                                    (item.label === 'Exchange Resources'
                                      ? ' - /exchange/resource/:id'
                                      : item.label === 'Exchange Sharemailbox'
                                        ? ' - /exchange/sharemailbox/:id'
                                        : '')
                                }})
                              </span>
                            </div>
                          </div>
                        }
                      </div>
                      <div fxFlex="50%" fxFlex.xs="100%">
                        @for (
                          item of getSecondHalf(categoryGroup.items);
                          track item
                        ) {
                          <div style="margin-bottom: 15px">
                            <div
                              fxLayout="row"
                              fxLayoutAlign="start center"
                              fxLayoutGap="10px">
                              <!-- All item toggle -->
                              @if (
                                categoryGroup.category === 'Full maintenance'
                              ) {
                                <mat-slide-toggle
                                  [(ngModel)]="item.isDisabled"
                                  (change)="
                                    onSpecialItemToggle($event.checked)
                                  ">
                                </mat-slide-toggle>
                              }
                              <!-- Regular items toggle -->
                              @if (
                                categoryGroup.category !== 'Full maintenance'
                              ) {
                                <mat-slide-toggle
                                  [(ngModel)]="item.isDisabled"
                                  [disabled]="isSpecialItemToggled"
                                  (change)="onToggle(item.url)">
                                </mat-slide-toggle>
                              }
                              <span>
                                {{ item.label }}
                                ({{
                                  item.url +
                                    (item.label === 'Exchange Resources'
                                      ? ' - /exchange/resource/:id'
                                      : item.label === 'Exchange Sharemailbox'
                                        ? ' - /exchange/sharemailbox/:id'
                                        : '')
                                }})
                              </span>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
          <button mat-raised-button color="accent" (click)="openDialog()">
            {{ 'GENERAL.SAVE' | translate }}
          </button>
        </div>
      }
    </div>
    <!-- / CONTENT CARD -->
  </div>
</div>
